import translations from './ruthenium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/ruthenium'

export const ruthenium: Metal = {
  id: 7,
  slug: 'ruthenium',
  name: t.name,
  symbol: 'Ru',
  // Recovered as a co-product of platinum-group metal mining.
  mines: [
    {
      name: 'Bushveld Complex, Rustenburg (South Africa, platinum-group mine)',
      region: 'Rustenburg',
      coordinates: [27.24, -25.67],
    },
    {
      name: 'Norilsk (Russia, Nornickel — platinum-group mine)',
      region: 'Norilsk',
      coordinates: [88.2, 69.33],
    },
    {
      name: 'Great Dyke (Zimbabwe, platinum-group mine)',
      region: 'Great Dyke',
      coordinates: [31.14, -16.46],
    },
  ],
  countries: [
    { name: 'South Africa', percent: 89.8 },
    { name: 'Zimbabwe', percent: 4.5 },
    { name: 'Russia', percent: 4.2 },
    { name: 'Canada', percent: 1.4 },
  ],
  related: ['palladium', 'platinum', 'nickel', 'copper'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 4, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
          credit: 'Bloomberg / Getty',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'Michel Lunanga / Getty',
        },
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/05.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
